import React, { Component } from 'react';
import propTypes from "prop-types";
import { connect } from "react-redux";
import * as Actions from '../actions';
import { bindActionCreators, compose } from 'redux';

// import components
import LoadingIndicator from '../components/LoadingIndicator.js';
import ObjectNotFound from '../components/items/ObjectNotFound.js';

//helper scripts
import components from '../scripts/ItemsTypes.js';
import withTitle from '../scripts/WithTitle.js';

class Result extends Component {
	componentDidMount() {
		const { actions, match: { params: { id, type } } } = this.props;
		//load result with name
		actions.fetchResult(id, type);
	};

	componentWillUnmount() {
		const { actions } = this.props;
		actions.resetResultData();
		actions.resetApiAddress();
	};

	componentDidUpdate(prevProps) {
		const { actions, clang, match: { params: { id, type } } } = this.props;
		if (type !== prevProps.match.params.type || id !== prevProps.match.params.id || clang !== prevProps.clang) {
			actions.resetResultData();
			actions.resetApiAddress();
			actions.fetchResult(id, type);
		}
	};

	getItemComponent = () => {
		const { match: { params: { type } }, data, history, showBackButton } = this.props;

		if (components[ type ]) {
			const ItemComponent = components[ type ];
			return <ItemComponent { ...data } type={ type } history={ history } showBackButton={ showBackButton } />;
		}

		return <ObjectNotFound />;
	};

	render() {
		const { isLoadingError, isLoading } = this.props;

		if (isLoadingError) {
			return <section className="item">
				<ObjectNotFound />
			</section>;
		}

		if (isLoading) {
			return <section className="item">
				<LoadingIndicator />
			</section>;
		}

		return (
			<section className="item">
				{ this.getItemComponent() }
			</section>
		);
	};
};

Result.propTypes = {
	actions: propTypes.object.isRequired,
	match: propTypes.shape({
		params: propTypes.shape({
			id: propTypes.string.isRequired,
			type: propTypes.string.isRequired
		})
	}),
	data: propTypes.shape({
		id: propTypes.string.isRequired
	}),
	isLoading: propTypes.bool.isRequired,
	isLoadingError: propTypes.bool.isRequired
};

const mapStateToProps = state => ({
	clang: state.language.currentLanguage,
	data: state.currentResult.resultData,
	isLoading: state.currentResult.isFetching,
	isLoadingError: state.currentResult.isLoadingError
});

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators(Actions, dispatch)
});

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	withTitle,
);

export default enhance(Result);



// WEBPACK FOOTER //
// ./src/containers/Item.js